import React from "react";

import { ReactComponent as IconInstagram } from "../../assets/icons/icon_instagram.svg";
import { ReactComponent as IconLinkedin } from "../../assets/icons/icon_linkedin.svg";
import { ReactComponent as IconTelegram } from "../../assets/icons/icon_telegram.svg";
import { ReactComponent as IconYoutube } from "../../assets/icons/icon_youtube.svg";
import logo_footer from "../../assets/images/logo_footer.png";
import socialLinks, { SocialLinkConfig } from "../../config/socialLinks";
import { ButtonAnchor } from "../ButtonAnchor/ButtonAnchor";

import {
  BlockSection,
  ButtonContainer,
  Contacts,
  Container,
  Copyright,
  FooterWrapper,
  LegalInfo,
  Logo,
  SectionTitle,
  SocialLink,
  SocialLinks,
  StyledLink,
} from "./styles";

const socialIcons = {
  instagram: IconInstagram,
  youtube: IconYoutube,
  linkedin: IconLinkedin,
  telegram: IconTelegram,
} satisfies Record<SocialLinkConfig["id"], React.ComponentType<React.SVGProps<SVGSVGElement>>>;

export const FooterMobile = () => {
  return (
    <FooterWrapper>
      <Container>
        <Logo src={logo_footer} />
        <LegalInfo>
          ИП Прохорова Любовь Васильевна <br/>
          Адрес: Россия, г. Краснодар, ул. Яна Полуяна 42<br />
          ОГРНИП: 321237500416095, ИНН: 231130103902
        </LegalInfo>
        <ButtonContainer>
          <ButtonAnchor
            href="https://t.me/ProhorovaConsult"
            title="Задать вопрос"
            bgColor="#BFDCF5"
          />
          <ButtonAnchor
            href="https://t.me/+pWQsax6E5mY2OGVi"
            title="Обсуждение ЗП в ИТ/Диджитал"
          />
        </ButtonContainer>
        <SectionTitle>Консалтинг</SectionTitle>
        <BlockSection>
          {/*TODO для новой страницы*/}
          {/*<StyledLink to="/services/c-level">Продвижение ТОП–менеджеров</StyledLink>*/}
          <StyledLink to="/services/search-support">Пакетное сопровождение</StyledLink>
          <StyledLink to="/services/probation-support">Сопровождение испытательного срока</StyledLink>
          <StyledLink to="/services/cv-ready">Резюме под ключ</StyledLink>
          <StyledLink to="/services/vacancies">Месячная подписка на поиск вакансий</StyledLink>
          <StyledLink to="/services/linkedin-boost">Развитие Linkedin профиля</StyledLink>
          <StyledLink to="/services/career-consul">Карьерная консультация</StyledLink>
          <StyledLink to="/services/talkitout">Карьерная сессия «Выговориться»</StyledLink>
        </BlockSection>
        <SectionTitle>Компания</SectionTitle>
        <BlockSection>
          <StyledLink to="/company">О нас</StyledLink>
          <StyledLink to="/services/it-hiring">ИТ подбор</StyledLink>
          <StyledLink to="/services/it-training">Обучение</StyledLink>
          <StyledLink to="/blog">Блог</StyledLink>
          <StyledLink to="/policy">Политика конфиденциальности</StyledLink>
        </BlockSection>
        <Contacts>
          <div>Часы работы: пн-пт, с 9:00 до 18:00</div>
          <div>Контакты: prohorovaconsult@yandex.ru</div>
        </Contacts>
        <SocialLinks>
          {[...socialLinks]
            .sort((firstLink, secondLink) => firstLink.order - secondLink.order)
            .map(({ id, href, label, ariaLabel }) => {
              const Icon = socialIcons[id];

              return (
                <SocialLink
                  key={id}
                  href={href}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label={ariaLabel ?? label}
                  title={label}
                >
                  <Icon />
                </SocialLink>
              );
            })}
        </SocialLinks>
        <Copyright>Copyright © ProhorovaConsult</Copyright>
      </Container>
    </FooterWrapper>
  );
};

